/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOffersResponse as ModelsCustomerCustomerOffersResponse } from '../../models/Models/Customer/customer-offers-response';

export interface V4CustomersMeNotificationsUnreadGet$Xml$Params {
}

export function v4CustomersMeNotificationsUnreadGet$Xml(http: HttpClient, rootUrl: string, params?: V4CustomersMeNotificationsUnreadGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeNotificationsUnreadGet$Xml.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOffersResponse>;
    })
  );
}

v4CustomersMeNotificationsUnreadGet$Xml.PATH = '/v4/customers/me/notifications/unread';
